<template>
    <div class="attention-toolset-container">
        <client-list
            ref="clientList"
            :individual-provider="!isInstitution"
            @change:events="onEventsChange"
        />
        <client-attention-history ref="clientAttentionHistory" />
        <appointment-provider-stepper
                ref="stepper"
                internal
        />

        <docs-manager
          v-if="currentEvent"
          :event="currentEvent"
          ref="docsManager"
          :docs="documents" />

        <video-call-tools v-if="showVCTools" />

        <floating-spinner v-if="requiresGlobalSpinner" />


      <v-speed-dial
          v-model="fab"
          bottom
          right
          direction="top"
          transition="slide-y-transition"
      >
        <template v-slot:activator>
          <v-btn
              v-model="fab"
              color="accent"
              dark
              fab
          >
            <v-icon v-if="fab">
              mdi-close
            </v-icon>
            <v-icon v-else>
              mdi-plus
            </v-icon>
          </v-btn>
        </template>

        <v-tooltip left >
          <template v-slot:activator="{on}">
            <v-btn
                class="ml-1"
                v-on="on"
                @click="() => setEvent(null)"
                color="error"
                dark fab small>
              <v-icon >mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <label>Volver al listado</label>
        </v-tooltip>

        <v-tooltip left >
          <template v-slot:activator="{on}">
            <v-btn
                v-on="on"
                :disabled="loadingEvent"
                @click="refreshEvent"
                color="success"
                dark fab small
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <label>Volver a cargar</label>
        </v-tooltip>


        <v-tooltip left>
          <template v-slot:activator="{on}">
            <v-btn
                v-on="on"
                fab
                dark
                small
                color="primary"
                @click="showNewAppointment(null)"
            >
              <v-icon>mdi-calendar</v-icon>
            </v-btn>
          </template>
          Nueva cita
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{on}">
            <v-btn
                v-on="on"
                fab
                dark
                small
                color="secondary"
                @click="showDocsManager"
            >
              <v-icon>mdi-paperclip</v-icon>
            </v-btn>
          </template>
          Adjuntos
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{on}">
            <v-btn
                v-on="on"
                fab
                dark
                small
                color="teal"
                @click="$refs.clientAttentionHistory.show(currentClient.id)"
            >
              <v-icon>mdi-account-details</v-icon>
            </v-btn>
          </template>
          Historial
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{on}">
            <v-btn
                v-on="on"
                fab
                dark
                small
                color="orange"
                @click="$refs.clientList.showClientList()"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          {{ getLabel('commons.client.plural')}} del día
        </v-tooltip>

      </v-speed-dial>

    </div>
</template>
<script>
    import ClientAttentionHistory from '@/components/appointments/attention/ClientAttentionHistory'
    import AppointmentProviderStepper from '@/components/appointments/AppointmentProviderStepper'
    import VideoCallTools from '@/components/appointments/attention/toolset/VideoCallTools'
    import DocsManager from '@/components/appointments/attention/DocsManager'
    import FloatingSpinner from '@/components/appointments/attention/toolset/FloatingSpinner'

    import ClientList from './ClientList'
    import {getLabel} from '@/utils/Institution'
    import {requiresGlobalSpinner} from '@/utils/Specialist'

    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'

    import {mapState, mapMutations} from 'vuex'
    import AppointmentsMixin from "@/mixins/AppointmentsMixin";

    export default{
        mixins: [AppointmentsMixin],
        data(){
            return {
                fab: false,
                hidden: false,
                documents: []
            }
        },
        components: {
            FloatingSpinner,
            ClientList,
            ClientAttentionHistory,
            AppointmentProviderStepper,
            VideoCallTools,
            DocsManager
        },
        mounted(){
            var vm = this
            if(vm.currentEvent){
                vm.connectSocket()
                vm.documents = vm.currentEvent.appointment_documents || []
            }
        },
        beforeDestroy(){
            var vm = this
            if(!vm.currentEvent) return
            leaveChannel(`appointment.${vm.currentEvent.id}`)
        },
        methods:{
            ...mapMutations('clientAttention', [
                'setEvent'
            ]),
            getLabel,

            refreshEvent() {
              const vm = this
              let currentEvent = JSON.parse(JSON.stringify(vm.currentEvent))
              vm.setEvent(currentEvent)
            },

            onEventsChange(events){
                const vm = this
                vm.$emit('change:events', events)
            },

            connectSocket(){
                var vm = this
                subscribeToPrivateChannelEvents(`appointment.${vm.currentEvent.id}`, {
                    AppointmentDocumentUploaded: vm.onDocumentUploaded,
                    AppointmentDocumentDeleted: vm.onDocumentDeleted,
                    PaymentUpdated: vm.onPaymentUpdated,
                    ClientArrived: vm.onClientArrived,
                    EventLabelsUpdated: vm.updateEventFromSocketUpdateSingle,
                    ClientAttentionEnd: vm.updateEventFromSocketUpdateSingle,
                })
            },
            onPaymentUpdated({event}){
                var vm = this

                if(vm.currentEvent && event.payment){
                    var currentEvent = JSON.parse(JSON.stringify(vm.currentEvent))
                    currentEvent.payment = event.payment
                    vm.setEvent(currentEvent)
                }
            },
            onClientArrived({event}){
                var vm = this
                if(vm.currentEvent && vm.currentEvent.event_status_id !== event.event_status_id){
                    vm.setEvent(event)
                }
            },
            onDocumentDeleted({document}){
              const vm = this
              const index = vm.documents.findIndex(doc => doc.id === document.id)
              if(index !== -1){
                vm.documents.splice(index, 1)
              }
            },
            onDocumentUploaded({document}){
                var vm = this
                if(document.user.id !== vm.currentUser.id){
                    vm.$store.commit('showSnackBar', {
                        text: 'Se ha cargado un nuevo documento',
                        color: 'success'
                    })
                }
                const index = vm.documents.findIndex(doc => doc.id === document.id)
                if(index === -1){
                  vm.documents.push(document)
                }
            },
            showDocsManager(){
                var vm = this
                vm.$refs.docsManager.show()
            },
            showNewAppointment(defaultAppointment = null){
                this.$refs.stepper.show(defaultAppointment)
            }
        },
        computed: {
            ...mapState('clientAttention', {
                currentClient: state => state.currentClient,
                currentEvent: state => state.currentEvent,
                loadingEvent: state => state.loading,
                attentionSummaryDrawer: state => state.attentionSummaryDrawer
            }),
                ...mapState(['currentUser', 'currentProvider']),
            requiresGlobalSpinner,
            isInstitution(){
                var vm = this
                return !!vm.currentProvider && !!vm.currentProvider.institution
            },
            showVCTools(){
                var vm = this
                return vm.currentEvent && !vm.loadingEvent &&
                        vm.currentEvent.type === 'video' &&
                        (
                            vm.currentEvent.event_status.id === 4
                        )
            }
        },
        watch:{
            currentEvent(val, oldVal){
                var vm = this

                if(oldVal){
                    leaveChannel(`appointment.${oldVal.id}`)
                }

                if(val){
                    vm.documents = val.appointment_documents || []
                    leaveChannel(`appointment.${val.id}`)
                    vm.connectSocket()
                }else{
                    vm.documents = []
                }
            },
        }
    }
</script>

<style scoped >

  >>>.v-speed-dial {
    position: fixed;
  }

 >>>.v-btn--floating {
    position: relative;
  }


    .toolset{
        bottom: -5px !important;
        transition: .3s bottom;
        font-family: Roboto, sans-serif;
        font-size: 12px !important;
    }

    .toolset.hidden{
        bottom: -45px !important;
    }

    .toolset.hidden .toolset-card{
        cursor: pointer;
    }

    .toolset-card{
      background: var(--v-secondary-card-base) !important;
      background: linear-gradient(0deg, rgba(255,255,255,0) 0%, var(--v-secondary-card-base) 80%) !important;
      padding: 10px 10px !important;
      margin: 0;
      border-radius: 20px 20px 0 0 !important;
    }

    .toolset-bg{
        position: absolute;
        background-size: cover;
        opacity: .6;
        background-position: center;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.8);
    }

    .close-btn{
        width: 35px;
        height: 35px;
    }


</style>
